import React from 'react';
import { Zap, Mail, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#040605] pt-16 pb-8 border-t border-white/10" data-id="element-297">
      <div className="container mx-auto px-4" data-id="element-298">
        <div className="grid md:grid-cols-2 gap-12 mb-12" data-id="element-299">
          <div data-id="element-300">
            <div className="flex items-center gap-2 mb-6" data-id="element-301">
              <Zap className="w-6 h-6 text-electric fill-electric" data-id="element-302" />
              <span className="font-bold text-xl tracking-tight" data-id="element-303">
                BIBLIOTECAS DIGITALES™
              </span>
            </div>
            <p className="text-textsecondary max-w-md mb-6" data-id="element-304">
              El sistema N°1 para profesionales del fitness que quieren crear y
              vender planes de nutrición online con IA.
              <br data-id="element-305" />
              <br data-id="element-306" />
              Porque escalar tu negocio no debería depender de que estés
              presente 12 horas al día sin un sistema que trabaje por vos.
            </p>
          </div>

          <div className="md:text-right flex flex-col md:items-end justify-center" data-id="element-307">
            <a href="mailto:soportebibliotecasdigitales@gmail.com" className="flex items-center gap-2 text-textsecondary hover:text-electric transition-colors mb-4" data-id="element-308">
              <Mail className="w-5 h-5" data-id="element-309" /> soportebibliotecasdigitales@gmail.com
            </a>
            <a href="#" className="flex items-center gap-2 text-textsecondary hover:text-electric transition-colors" data-id="element-310">
              <Globe className="w-5 h-5" data-id="element-311" /> www.bibliotecasdigitales.store
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-textsecondary/60" data-id="element-312">
          <p data-id="element-313">
            © Bibliotecas Digitales™ 2025 — Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}